import { makeStyles, createStyles } from "@mui/styles";
// import { Theme } from "@mui/material";
import customColors from "../../styles/coreStyles/ColorPalette";
import customFonts from "../../styles/coreStyles/Fonts";

const EditBookingStyle = makeStyles(() =>
  createStyles({
    container: {
      padding: "1rem",
      borderRadius: "8px",
    },
    titlesBoxStyle: {
      margin: "0.5rem",
      padding: "0.5rem",
      color: customColors.groupBlue,
    },
    textAndDropdownGrids: {
      padding: "1rem",
    },
    formControl: {
      width: "100%",
    },
    inputLabelAndMenuItems: {
      fontFamily: customFonts.regularFont,
      color: customColors.groupBlue,
    },
    typography: {
      fontFamily: customFonts.boldFont,
      fontSize: "1.5rem",
    },
    textField: {
      width: "100%",
      "& label": {
        fontFamily: customFonts.regularFont,
        color: customColors.groupBlue,
      },
    },
    dividers: {
      height: 1,
      background: customColors.textGrey,
      opacity: 0.25,
    },
    buttons: {
      backgroundColor: "transparent",
      fontFamily: customFonts.boldFont,
    },
    cancelButton: {
      color: customColors.textGrey,
    },
    okButton: {
      color: customColors.actionBlue,
    },
  })
);

export default EditBookingStyle;
